import styled from 'styled-components';

const DetailGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }
`;

const GroupContent = styled.div``;

export { DetailGroupWrapper, GroupContent };
